/* eslint-disable sonarjs/no-duplicate-string */

import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  getFilterData,
  getLeagues,
} from '../../../selectors/common';


import {
  getEvents, getTimeHeaders, getLastEventId, getLastDate,
} from '../../../selectors/events';
import {
  FILTERS_NAMES, FILTER_FIELDS, FILTER_SHOW_DROPDOWN, SHOW_FILTERS,
} from '../../../constants';
import Events from '..';
import {
  aBookEvents, aGetEvents, aResetEventDetails, aUnbookEvents, aBulkBookEvents, aBulkUnbookEvents,
} from '../../../reducers';

const mapToProps = (state) => ({
  filters: getFilterData(state),
  events: getEvents(state),
  timeHeaders: getTimeHeaders(state),
  leagues: getLeagues(state),
  lastEventId: getLastEventId(state),
  lastDate: getLastDate(state),

});

const actionsToProps = (dispatch) => ({
  getEvents: (payload) => dispatch(aGetEvents(payload)),
  bookEvents: (payload) => dispatch(aBookEvents(payload)),
  unbookEvents: (payload) => dispatch(aUnbookEvents(payload)),
  bulkBookEvents: (payload) => dispatch(aBulkBookEvents(payload)),
  bulkUnbookEvents: (payload) => dispatch(aBulkUnbookEvents(payload)),
  resetDetailsForEvents: (payload) => dispatch(aResetEventDetails(payload)),

});

class SoccerEvents extends Component {
  constructor(props) {
    super(props);

    /**
     * @member {Array}
     * @description Filtering fields settings
     */
    this.filterFields = [
      {
        text: FILTERS_NAMES.DATE,
        field: ['filterStartDate', 'filterEndDate'],
        dateInterval: true,
      },
      {
        text: FILTERS_NAMES.LEAGUE,
        field: 'filterLeague[]',
        selections: props.leagues.map((league) => ({
          id: league.id,
          label: league.name,
        })),
      },
      {
        text: FILTERS_NAMES.MATCH_ID,
        field: 'filterMatchId',
        type: 'number',
      },
      {
        text: FILTERS_NAMES.TEAM_NAME,
        field: 'filterTeamsName',
      },
      {
        text: FILTERS_NAMES.SHOW,
        field: 'filterShow',
        dropdown: FILTER_SHOW_DROPDOWN,
      },
      {
        text: FILTERS_NAMES.HIDE_ENDED_MATCHES,
        field: 'filterHideEndedMatches',
        checkbox: true,
      },
    ];

    this.defaultFilter = {
      filterStartDate: '',
      filterEndDate: '',
    };

    /**
     * @member {object}
     */
    this.state = {
      filters : this.defaultFilter,
      selectedItem : {
        [FILTER_FIELDS.FILTER_LEAGUE_ARRAY]: [],
        [FILTER_FIELDS.FILTER_SHOW_RANGE]:  SHOW_FILTERS.ALL,
      }
    };

    this.headersTable = [
      'Match ID', 'Date', 'Status', 'Team Home', 'Score', 'Team Away', 'League', 'Season', 'Round',
    ];
  }

  componentDidUpdate(prevProps) {
    if(prevProps.filters !== this.props.filters){
      this.setState({
        filters : { ...this.props.filters } ,
        selectedItem : {
          [FILTER_FIELDS.FILTER_LEAGUE_ARRAY]: this.props.filters && this.props.filters['filterLeague[]'] ? [...this.props.filters['filterLeague[]']]:[],
          [FILTER_FIELDS.FILTER_SHOW_RANGE]: FILTER_SHOW_DROPDOWN.find((status) => parseInt(status.id)
          === (parseInt(this.props.filters?.filterShow) || SHOW_FILTERS.ALL)),
        }
      });
    }
  }

  /**
   * Render
   *
   * @returns {view}
   */
  render() {
    return (
      <Events
        filtersParams={this.state.filters}
        selectedItem={this.state.selectedItem}
        defaultFilter={this.defaultFilter}
        filterFields={this.filterFields}
        getEvents={this.props.getEvents}
        bookEvents={this.props.bookEvents}
        unbookEvents={this.props.unbookEvents}
        bulkBookEvents={this.props.bulkBookEvents}
        bulkUnbookEvents={this.props.bulkUnbookEvents}
        resetDetailsForEvents={this.props.resetDetailsForEvents}
        events={this.props.events}
        timeHeaders={this.props.timeHeaders}
        leagues={this.props.leagues}
        lastEventId={this.props.lastEventId}
        lastDate={this.props.lastDate}
        headers={this.headersTable}
      />

    );
  }
}

export default connect(mapToProps, actionsToProps)(SoccerEvents);
